<template>
  <div class="back-pop">
    <div class="title">还有5S出额度，确定要放弃吗</div>
    <div class="process">
      <audit-progress :progress="progress"/>
    </div>
    <div class="actions">
      <nd-button class="btn line small cancel" @click="$emit('jumpHomeAction')">放弃特权</nd-button>
      <nd-button class="btn small confirm" @click="$emit('jumpBuy')">立即加速，免排队</nd-button>
    </div>
    <img class="percent" src="../images/img_percentBubble.png">
    <div class="protocol">
      开通即同意<span @click="$emit('toProtocol')">《会员用户协议》</span>
    </div>
  </div>
</template>

<script>
import AuditProgress from './audit-progress.vue'
export default {
  components: {
    AuditProgress
  },
  props: {
    progress: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.back-pop {
  background-color: white;
  width: 620;
  height: 420px;
  padding: 0px 30px;
  .title {
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 50px;
    width: 100%;
    text-align: center;
  }
  .process {
    width: 560px;
    height: 131px;
    background-color: #FAFAFA;
    padding: 36px 58px 0 30px;
    border-radius: 20px;
    margin-top: 19px;
  }
  .actions {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin-top: 44px;
    .cancel {
      width: 210px;
      height: 80px;
    }
    .confirm {
      width: 330px;
      height: 80px;
    }
  }
  .percent {
    position: absolute;
    top: 261px;
    left: 376px;
    width: 189px;
    height: 41px;
  }
  .protocol {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 33px;
    text-align: center;
    margin-top: 23px;
    span {
      color: #8EB2D8;
    }
  }
}
</style>